"use client";

import React from "react";
import { Search, Activity } from "lucide-react";
import { Input } from "@/components/ui/input";
export default function TopSecurityPicks2026() {
  return <section data-section-id="255736" id="top-security-picks-2026" className="bg-background text-foreground relative overflow-hidden py-24 min-h-screen flex flex-col">
      {}
      <div className="absolute top-[-10%] left-[-10%] w-[40%] h-[40%] bg-secondary/5 rounded-lg blur-[120px] pointer-events-none" />
      <div className="absolute bottom-[-10%] right-[-10%] w-[30%] h-[40%] bg-primary/5 rounded-lg blur-[100px] pointer-events-none" />
      <div className="absolute top-[40%] left-[60%] w-[20%] h-[20%] bg-chart-3/5 rounded-lg blur-[80px] pointer-events-none" />

      <div className="container max-w-5xl mx-auto px-4 relative z-10 flex-1 flex flex-col">
        
        {}
        <div className="flex flex-col md:flex-row justify-between items-start md:items-end mb-8 gap-6">
          <div>
            <h2 className="text-4xl md:text-5xl font-default font-bold tracking-tight mb-2 flex items-center gap-3 text-primary">
              <Activity className="w-8 h-8 text-secondary" />
              Top Security Picks 2026
            </h2>
            <p className="text-muted-foreground text-sm md:text-lg max-w-md font-default">
              Expert-tested rankings and performance metrics for the year's leading home safety systems.
            </p>
          </div>
          
          <div className="relative w-full md:w-72">
            <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-muted-foreground" />
            <Input type="text" placeholder="Search products..." className="pl-9 bg-card border-border focus-visible:ring-secondary/50 rounded-lg" disabled />
          </div>
        </div>

        {}
        <div className="rounded-2xl border border-border bg-card shadow-xl overflow-hidden flex-1 flex flex-col">
          
          {}
          <div className="grid grid-cols-4 md:grid-cols-12 gap-4 px-6 py-4 bg-primary border-b border-border text-xs font-default font-bold text-primary-foreground uppercase tracking-widest">
            <div className="col-span-1 md:col-span-1 text-center">Rank</div>
            <div className="col-span-2 md:col-span-4">Product</div>
            <div className="hidden md:block md:col-span-4">Rating Trend</div>
            <div className="col-span-1 md:col-span-3 text-right">Expert Score</div>
          </div>

          {}
          <div className="flex-1 overflow-y-auto">
            <div className="flex items-center justify-center py-20 text-center px-4">
              <p className="text-muted-foreground font-default text-lg">
                Our expert rankings are being finalized — check back soon.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}